import { render, staticRenderFns } from "./OverviewInfo.vue?vue&type=template&id=a0c92592&scoped=true&"
import script from "./OverviewInfo.vue?vue&type=script&lang=js&"
export * from "./OverviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./OverviewInfo.vue?vue&type=style&index=0&id=a0c92592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c92592",
  null
  
)

export default component.exports